var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M371.606 335.692L370.974 336.5H372H388.3C394.569 336.5 400.541 338.949 404.946 343.354L504.645 443.052C513.752 452.257 513.751 467.141 504.546 476.346L476.246 504.646L476.245 504.648C467.141 513.849 452.259 513.852 443.054 504.646L343.354 404.946C338.949 400.541 336.5 394.569 336.5 388.3V372V370.974L335.692 371.606C300.477 399.14 256.185 415.5 208 415.5C93.3761 415.5 0.5 322.624 0.5 208C0.5 93.3761 93.3761 0.5 208 0.5C322.624 0.5 415.5 93.3761 415.5 208C415.5 256.185 399.14 300.477 371.606 335.692ZM79.5 208C79.5 279.076 137.024 336.5 208 336.5C279.076 336.5 336.5 278.976 336.5 208C336.5 136.924 278.976 79.5 208 79.5C136.924 79.5 79.5 137.024 79.5 208Z",
    fill: "#767676",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSolid);
export default __webpack_public_path__ + "static/media/search-solid.bd3a4b32317e0d46cfdaad4d5021f706.svg";
export { ForwardRef as ReactComponent };